import React from "react";

const LessonWizard = ({
    lessonDraftTitle,
    setLessonDraftTitle,

    lessonDraftChapter,
    setLessonDraftChapter,

    lessonDraftSection,
    setLessonDraftSection,

    lessonDraftNumber,
    setLessonDraftNumber,

    notebookPages,
    setNotebookPages,

    notebookPagesStorageKey,

    setActiveNotebookPageId,
    onNotesChange,

    setExpandedChapters,

    chapterNames,
    setIsChapterWizardOpen,

    setIsLessonWizardOpen,
    }) => {
    const closeLessonWizard = () => {
        setIsLessonWizardOpen(false);
        setLessonDraftTitle("");
        setLessonDraftChapter("");
        setLessonDraftSection("");
        setLessonDraftNumber("");
    };

    const createLesson = () => {
        const timestamp =
            new Date().toISOString();

        const lessonNumber =
            Number(
                lessonDraftNumber
            ) ||
            notebookPages.length + 1;

        const newPage = {
            id: `note-page-${Date.now()}-${Math.random()
                .toString(36)
                .slice(2, 8)}`,

            pageType: "lesson",

            title:
                lessonDraftTitle.trim() ||
                `Lesson ${lessonNumber}`,

            chapterTitle:
                lessonDraftChapter.trim(),

            unitTitle: "",

            sectionTitle:
                lessonDraftSection.trim(),

            lessonNumber,

            content: "",

            createdAt: timestamp,
            updatedAt: timestamp,
        };

        const updatedPages = [
            ...notebookPages,
            newPage,
        ];

        setNotebookPages(
            updatedPages
        );

        setActiveNotebookPageId(
            newPage.id
        );

        onNotesChange("");

        try {
            localStorage.setItem(
                notebookPagesStorageKey,
                JSON.stringify(
                    updatedPages
                )
            );
        } catch (error) {
            console.error(
                "Unable to save new lesson:",
                error
            );
        }

        setExpandedChapters(
            (current) => ({
                ...current,

                [newPage.chapterTitle ||
                "Unassigned"]: true,
            })
        );

        closeLessonWizard();
    };

    return (
        <div className="mt-3 rounded-2xl border border-[#ffd166]/25 bg-[#05070d] p-4 shadow-[0_0_24px_rgba(255,209,102,0.10)]">
            <div className="mb-3">
                <p className="text-[10px] uppercase tracking-[0.18em] text-[#d8b4fe]">
                    New Lesson
                </p>

                <p className="mt-1 text-xs text-[#b0b8d6]">
                    Add this lesson to the
                    notebook Table of Contents.
                </p>
            </div>

            <div className="grid gap-3 sm:grid-cols-2">
                <div className="sm:col-span-2">
                    <label className="mb-1 block text-[10px] font-semibold uppercase tracking-[0.14em] text-[#ffd166]">
                        Lesson Title
                    </label>

                    <input
                        type="text"
                        value={
                            lessonDraftTitle
                        }
                        onChange={(event) =>
                            setLessonDraftTitle(
                                event.target.value
                            )
                        }
                        placeholder="Example: The Nile River"
                        className="
                            w-full
                            rounded-xl
                            border
                            border-[#ffd166]/30
                            bg-[#080b14]
                            px-3
                            py-2
                            text-sm
                            text-[#fff3c4]
                            outline-none
                            placeholder:text-[#6c7a9c]
                            focus:border-[#ffd166]
                        "
                    />
                </div>

                <div>
                    <label className="mb-1 block text-[10px] font-semibold uppercase tracking-[0.14em] text-[#d8b4fe]">
                        Chapter
                    </label>

                    <select
                        value={
                            lessonDraftChapter
                        }
                        onChange={(event) =>
                            setLessonDraftChapter(
                                event.target.value
                            )
                        }
                        className="
                            w-full
                            rounded-xl
                            border
                            border-[#c084fc]/30
                            bg-[#080b14]
                            px-3
                            py-2
                            text-xs
                            text-[#fff3c4]
                            outline-none
                            focus:border-[#c084fc]
                        "
                    >
                        <option value="">
                            Select a chapter
                        </option>

                        {chapterNames.map(
                            (chapterName) => (
                                <option
                                    key={
                                        chapterName
                                    }
                                    value={
                                        chapterName
                                    }
                                >
                                    {chapterName}
                                </option>
                            )
                        )}
                    </select>

                    <button
                        type="button"
                        onClick={() => {
                            setIsChapterWizardOpen(
                                true
                            );
                        }}
                        className="
                            mt-2
                            rounded-lg
                            border
                            border-[#ffd166]/30
                            bg-black
                            px-2.5
                            py-1.5
                            text-[10px]
                            font-semibold
                            text-[#ffd166]
                            transition
                            hover:border-[#ffd166]
                            hover:bg-[#ffd166]/10
                        "
                    >
                        + New Chapter
                    </button>
                </div>

                <div>
                    <label className="mb-1 block text-[10px] font-semibold uppercase tracking-[0.14em] text-[#d8b4fe]">
                        Lesson Number
                    </label>

                    <input
                        type="number"
                        min="1"
                        value={
                            lessonDraftNumber
                        }
                        onChange={(event) =>
                            setLessonDraftNumber(
                                event.target.value
                            )
                        }
                        className="
                            w-full
                            rounded-xl
                            border
                            border-[#c084fc]/30
                            bg-[#080b14]
                            px-3
                            py-2
                            text-xs
                            text-[#fff3c4]
                            outline-none
                            focus:border-[#c084fc]
                        "
                    />
                </div>

                <div className="sm:col-span-2">
                    <label className="mb-1 block text-[10px] font-semibold uppercase tracking-[0.14em] text-[#d8b4fe]">
                        Section / Topic
                    </label>

                    <input
                        type="text"
                        value={
                            lessonDraftSection
                        }
                        onChange={(event) =>
                            setLessonDraftSection(
                                event.target.value
                            )
                        }
                        placeholder="Example: Geography"
                        className="
                            w-full
                            rounded-xl
                            border
                            border-[#c084fc]/30
                            bg-[#080b14]
                            px-3
                            py-2
                            text-xs
                            text-[#fff3c4]
                            outline-none
                            placeholder:text-[#6c7a9c]
                            focus:border-[#c084fc]
                        "
                    />
                </div>
            </div>

            <div className="mt-4 flex flex-wrap justify-end gap-2">
                <button
                    type="button"
                    onClick={
                        closeLessonWizard
                    }
                    className="
                        rounded-xl
                        border
                        border-[#c084fc]/30
                        bg-black
                        px-3
                        py-2
                        text-xs
                        text-[#d8b4fe]
                        transition
                        hover:border-[#c084fc]/70
                    "
                >
                    Cancel
                </button>

                <button
                    type="button"
                    onClick={
                        createLesson
                    }
                    className="
                        rounded-xl
                        border
                        border-[#ffd166]/50
                        bg-[#2b1548]/80
                        px-4
                        py-2
                        text-xs
                        font-semibold
                        text-[#ffd166]
                        transition
                        hover:border-[#ffd166]
                        hover:bg-[#ffd166]/10
                    "
                >
                    Create Lesson
                </button>
            </div>
        </div>
    );
};

export default LessonWizard;